<template>
  <v-select
    :items="userOptions"
    v-model="assignedUsers"
    item-value="email"
    item-text="name"
    :placeholder="label"
    :hint="label"
    :disabled="disabled"
    multiple
  />
</template>

<script>

export default {
  name: 'UserMultiSelect',
  props: {
    label: {
      type: String,
      default: '',
    },
    initialValue: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    assignedUsers(newValue) {
      this.$emit('changed', newValue);
    },
  },
  computed: {
    userOptions() {
      return this.$store.state.users.filter(x => !!x.name);
    },
  },
  methods: {
    clear() {
      this.assignedUsers = this.getInitialAssignedUsers(this.initialValue);
    },
    getInitialAssignedUsers(initialValue) {
      if (!initialValue) {
        return [];
      }

      const userOptions = this.$store.state.users.filter(x => !!x.name);

      return userOptions
        .filter(x => initialValue.includes(x.name))
        .map(x => x.email);
    },
  },
  data() {
    return {
      assignedUsers: this.getInitialAssignedUsers(this.initialValue),
    };
  },
};
</script>
